import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Container,
    HStack,
    IconButton,
    Tooltip,
    useToast,
    VStack,
} from '@chakra-ui/react';
import React from 'react';
import { FiArrowLeft, FiRefreshCw } from 'react-icons/fi';
import { Link as RouterLink } from 'react-router-dom';
import RegistrationFilters from '../../components/RegistrationFilters';
import RegistrationList from '../../components/RegistrationList';
import { useRegistrationList } from '../../hooks/useRegistrationList';

const RegistrationListPage: React.FC = () => {
  const {
    inscricoes,
    loading,
    loadingMore,
    error,
    hasMore,
    total,
    stats,
    filters,
    handleLoadMore,
    handleFilter,
    handleClearFilters,
    refresh,
    copyAccessCode
  } = useRegistrationList();

  const toast = useToast();

  const handleRefresh = () => {
    refresh();
    toast({
      title: 'Lista atualizada',
      description: 'Os dados foram recarregados com sucesso',
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
  };

  return (
    <Container maxW="8xl" py={8}>
      {/* Breadcrumb e Ações */}
      <HStack justify="space-between" mb={6}>
        <Breadcrumb>
          <BreadcrumbItem>
            <BreadcrumbLink as={RouterLink} to="/admin">
              Admin
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink>Usuários Inscritos</BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>

        <HStack spacing={2}>
          <Tooltip label="Atualizar lista">
            <IconButton
              aria-label="Atualizar lista"
              icon={<FiRefreshCw />}
              variant="outline"
              onClick={handleRefresh}
              isLoading={loading}
            />
          </Tooltip>
          <Tooltip label="Voltar ao Dashboard">
            <IconButton
              aria-label="Voltar ao Dashboard"
              icon={<FiArrowLeft />}
              variant="outline"
              as={RouterLink}
              to="/admin"
            />
          </Tooltip>
        </HStack>
      </HStack>

      {/* Conteúdo Principal */}
      <VStack spacing={6} align="stretch">
        {/* Filtros */}
        <RegistrationFilters
          filters={filters}
          onFilter={handleFilter}
          onClearFilters={handleClearFilters}
          totalRecords={total}
          currentRecords={inscricoes.length}
          stats={stats}
          isLoading={loading}
        />

        {/* Lista de Inscrições */}
        <RegistrationList
          inscricoes={inscricoes}
          loading={loading}
          loadingMore={loadingMore}
          hasMore={hasMore}
          error={error}
          onLoadMore={handleLoadMore}
          onRefresh={handleRefresh}
          onCopyAccessCode={copyAccessCode}
        />
      </VStack>
    </Container>
  );
};

export default RegistrationListPage; 